import { Controller } from "@hotwired/stimulus";

export class VacancySelectionController extends Controller {
  static targets = ["bulkDeleteButton", "selectAllCheckbox"];
  static values = {
    bulkDeleteUrl: String,
  };

  connect() {
    this.selectedIds = new Set();
    this.updateBulkDeleteVisibility();

    this._onHtmxAfterSwap = this._onHtmxAfterSwap.bind(this);
    document.body.addEventListener("htmx:afterSwap", this._onHtmxAfterSwap);
  }

  disconnect() {
    document.body.removeEventListener("htmx:afterSwap", this._onHtmxAfterSwap);
  }

  _onHtmxAfterSwap(event) {
    // Only reset if the swapped element is our list container
    if (event.detail.target.id !== "vacancy-list-container") return;

    this.selectedIds.clear();
    this.updateBulkDeleteVisibility();

    if (this.hasSelectAllCheckboxTarget) {
      this.selectAllCheckboxTarget.checked = false;
      this.selectAllCheckboxTarget.indeterminate = false;
    }
  }

  toggleRow(event) {
    const checkbox = event.currentTarget;
    const id = checkbox.value;

    if (checkbox.checked) {
      this.selectedIds.add(id);
    } else {
      this.selectedIds.delete(id);
    }

    this.updateBulkDeleteVisibility();
    this.updateSelectAllState();
  }

  toggleAll(event) {
    const checkboxes = this.element.querySelectorAll(
      '#vacancy-list-container input[name="vacancy_ids"]',
    );
    const isChecked = event.currentTarget.checked;

    checkboxes.forEach((checkbox) => {
      checkbox.checked = isChecked;
      const id = checkbox.value;
      if (isChecked) {
        this.selectedIds.add(id);
      } else {
        this.selectedIds.delete(id);
      }
    });

    this.updateBulkDeleteVisibility();
  }

  updateBulkDeleteVisibility() {
    if (this.selectedIds.size > 0) {
      this.bulkDeleteButtonTarget.classList.remove("hidden");
    } else {
      this.bulkDeleteButtonTarget.classList.add("hidden");
    }
  }

  updateSelectAllState() {
    if (!this.hasSelectAllCheckboxTarget) return;

    const checkboxes = this.element.querySelectorAll(
      '#vacancy-list-container input[name="vacancy_ids"]',
    );
    const checkedCount = Array.from(checkboxes).filter(
      (cb) => cb.checked,
    ).length;

    if (checkedCount === 0) {
      this.selectAllCheckboxTarget.checked = false;
      this.selectAllCheckboxTarget.indeterminate = false;
    } else if (checkedCount === checkboxes.length) {
      this.selectAllCheckboxTarget.checked = true;
      this.selectAllCheckboxTarget.indeterminate = false;
    } else {
      this.selectAllCheckboxTarget.checked = false;
      this.selectAllCheckboxTarget.indeterminate = true;
    }
  }

  getCSRFToken() {
    const name = "csrftoken";
    const cookies = document.cookie.split(";");

    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(name + "=")) {
        return decodeURIComponent(cookie.substring(name.length + 1));
      }
    }

    return "";
  }
}
